import React, { useState, useEffect } from 'react';
import { faFileAlt, faFileImage, faPencilAlt, faSave, faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row, Col, Button } from 'reactstrap';
import moment from 'moment/moment';

//Components
import MainCard from '../../components/MainCard/MainCard';
import Loading from '../../components/Loading/Loading';
import ModalCustomized from '../../components/Modal/Modal';
import TextField from '../../components/TextField/TextField';

//Api
import notificacao_api from '../../api/notificacao_api';

//Helpers
import { showMessage } from '../../helpers/message';
import { getSessionCookie } from '../../helpers/cookies';
import uuid from 'helpers/guid';

function initialStateJustificativa(tbNotificacao_id) {
    return {
        tbNotificacao_id: tbNotificacao_id,
        dataHora: "",
        observacoes: "",
        status: "Aguardando Análise",
        anexo: "",
        anexoBase64: "",
    }
}

export default function FichaNotificacao({ id, btnVoltar }) {
    //Variavel com os dados do usuario logado
    const usuario = getSessionCookie();

    //Estado de controle de visibilidade do modal
    const [openModal, setOpenModal] = useState(false);

    //Função que faz a troca de visibilidade do modal
    const toggleModal = () => setOpenModal(prev => !prev);

    //Estado de controle dos dados da notificação buscada
    const [notificacao, setNotificacao] = useState({});

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado inicial da justificativa
    const [justificativa, setJustificativa] = useState(initialStateJustificativa(id));

    //Estado de controle de erros na justificativa
    const [errorsJustificativa, setErrorsJustificativa] = useState({});

    //Estado de controle da ação executada ao clicar em um dos botões
    const [titleModal, setTitleModal] = useState("+ Justificar");

    //Carregando os dados da notificacao
    const loadNotificacao = () => {
        setLoading(true);
        notificacao_api.GetItem(id).then(response => {
            if (response.data.justificativas) {
                response.data.justificativas = response.data.justificativas.map(value => {
                    value.dataHora = moment(new Date(value.dataHora)).format("DD/MM/YYYY HH:mm");
                    return value;
                });
            }
            response.data.respostasJustificativa = response.data.respostasJustificativa.map(value => {
                return { value: value.id, label: value.descricao };
            });
            setNotificacao(response.data);
        }).catch(e => {
            showMessage("Aviso!", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    useEffect(() => {
        loadNotificacao();
    }, []);


    //Função que realiza o cadastro da justificativa
    const enviarAcao = () => {
        switch (titleModal) {
            case "+ Justificar":
                cadastrarJustificativa();
                break;
            case "Baixar sem justificativa":
            case "Aprovar justificativa":
            case "Reprovar justificativa":
            case "Confirmar notificação":
                enviarDadosFiscal();
                break;
        }

    }
    //função que realiza o cadastro da justificativa
    const cadastrarJustificativa = () => {
        if (!justificativa.observacoes || !justificativa.tbTipoNotificacaoJustificativa_Id) {
            setErrorsJustificativa({ observacoes: !justificativa.observacoes ? "Campo vazio" : null, tbTipoNotificacaoJustificativa_Id: !justificativa.tbTipoNotificacaoJustificativa_Id ? "Campo vazio" : null });
            return;
        }

        const _justificativa = { ...justificativa };
        _justificativa.dataHora = moment(new Date()).format("YYYY-MM-DD HH:mm");

        setLoading(true);
        notificacao_api.SalvarJustificativa(_justificativa).then(response => {
            showMessage("Sucesso", "Justificativa salva com sucesso!", "success", null);
            setJustificativa(initialStateJustificativa(id));
            loadNotificacao();
            toggleModal();
            setErrorsJustificativa({});
        }).catch(e => {
            showMessage("Aviso!", e.message, "error")
        }).finally(f => setLoading(false));
    }

    //Função de atualização dos dados da justificativa pelo fiscal
    const enviarDadosFiscal = () => {
        if (!justificativa.observacoes) {
            setErrorsJustificativa({ observacoes: "Campo vazio" });
            return;
        }
        const _justificativa = {
            ...!!notificacao.justificativas ? notificacao.justificativas[0] : {},
            dataHoraAnalise: moment(new Date()).format("YYYY-MM-DD HH:mm"),
            observacoesFiscal: justificativa.observacoes,
            tbNotificacao_id: id
        };

        switch (titleModal) {
            case "Baixar sem justificativa":
                _justificativa.status = "Baixado sem justificativa";
                break;
            case "Confirmar notificação":
                _justificativa.status = "Notificação confirmada sem justificativa";
                break;
            case "Aprovar justificativa":
                _justificativa.status = "Analisado e Aceitado";
                break;
            case "Reprovar justificativa":
                _justificativa.status = "Analisado e Recusado";
                break;
        }
        if (_justificativa.status === "Baixado sem justificativa") {
            _justificativa.dataHora = moment(new Date()).format("YYYY-MM-DD HH:mm");
        } else {
            delete _justificativa.dataHora;
        }
        setLoading(true);
        notificacao_api.AtualizarJustificativaFiscal(_justificativa).then(response => {
            showMessage("Sucesso!", "Justificativa analisada com sucesso!", "success", null);
            setJustificativa(initialStateJustificativa(id));
            loadNotificacao();
            toggleModal();
        }).catch(e => showMessage("Aviso!", e.message, "error", null))
            .finally(f => setLoading(false));

    }
    //Função que faz o controle do onChange da justificativa
    const onChangeJustificativa = (e) => {
        const { name, value } = e.target;
        setJustificativa({
            ...justificativa,
            [name]: value
        })
    }

    //Função de onChange do select
    const onChangeTipoJustificativa = (e, select) => {
        const { name } = select;
        setJustificativa({
            ...justificativa,
            [name]: e.value
        });
    }
    //Cabeçalhos da tabela de justificativas
    const headers = [
        { value: "Data/Hora da justificativa", objectValue: "dataHora" },
        { value: "Observações", objectValue: "observacoes" },
        { value: "Observações do fiscal", objectValue: "observacoesFiscal" },
        {
            value: "Status", objectValue: "status", align: "left", options: {
                customBodyRenderLite: (dataIndex) => {
                    let bgStatus = "warning";

                    if (notificacao.justificativas[dataIndex].status === "Analisado e Aceitado" || notificacao.justificativas[dataIndex].status === "Baixado sem justificativa")
                        bgStatus = "success";
                    else if (notificacao.justificativas[dataIndex].status === "Analisado e Recusado")
                        bgStatus = "danger";
                    return (
                        <div className='d-flex align-items-center justify-content-start'><span style={{ padding: "5px", borderRadius: "50%" }} className={`me-3 bg-${bgStatus}`}></span><span>{notificacao.justificativas[dataIndex].status}</span></div>
                    )
                }
            }
        }
    ];
    //Função de controle de exibição do botão de ação 1
    const BtnAction1 = () => {
        if (usuario.acesso.sigla == "FS" && !!notificacao) {
            if (notificacao.status == "Aguardando Justificativa")
                return (<Button onClick={() => {
                    setTitleModal("Baixar sem justificativa");
                    toggleModal();
                }} color='success'><FontAwesomeIcon icon={faCheck} /> Baixar sem justificativa</Button>)
            else if (notificacao.status == "Aguardando Análise")
                return (<Button onClick={() => {
                    setTitleModal("Aprovar justificativa");
                    toggleModal();
                }} color='success'><FontAwesomeIcon icon={faCheck} /> Aprovar</Button>)

        }
        return null;
    }
    const BtnAction2 = () => {
        if (usuario.acesso.sigla == "FS" && !!notificacao) {
            if (notificacao.status == "Aguardando Análise") {
                return (<Button onClick={() => {
                    setTitleModal("Reprovar justificativa");
                    toggleModal();
                }} className='ms-3' color='danger'><span className="fw-bold">X</span> Reprovar</Button>)
            } else if (notificacao.status == "Aguardando Justificativa" && (new Date()).getTime() > (new Date(notificacao.prazoJustificativa)).getTime()) {
                return (<Button onClick={() => {
                    setTitleModal("Confirmar notificação");
                    toggleModal();
                }} className='ms-3' color='danger'><span className="fw-bold">X</span> Confirmar Notificação</Button>)
            }
        }
        return null;

    }

    //Change do anexo da justificativa
    const onChangeAnexo = (e) => {
        if (!e.target.files || !e.target.files[0]) {
            setJustificativa({
                ...justificativa,
                anexo: "",
                anexoBase64: "",
            });
            return;
        }

        if (e?.target?.files[0]?.type.startsWith("image/")) {
            const FR = new FileReader();

            FR.addEventListener("load", function (evt) {
                let base64 = evt.target.result;
                setJustificativa({
                    ...justificativa,
                    anexo: uuid() + ".png",
                    anexoBase64: base64.replace("data:image/png;base64,", "").replace("data:image/jpeg;base64,", "")
                })
            });

            FR.readAsDataURL(e.target.files[0]);
        } else {
            showMessage("Aviso", "Apenas arquivos de imagem no formato PNG ou JPEG são permitidos. Por favor, selecione um arquivo válido.", "warning", null);
            return
        }
    }
    return (
        <MainCard
            btnVoltar={btnVoltar}
            btnCadastro={usuario.acesso.sigla != "FS" && notificacao && notificacao.status == "Aguardando Justificativa" ? "Justificar" : null}
            onClickBtnCadastro={toggleModal}
            BtnAction1={usuario.acesso.sigla == "FS" ? BtnAction1 : null}
            BtnAction2={usuario.acesso.sigla == "FS" ? BtnAction2 : null}
        >
            <div style={{ color: "#666" }}>
                {loading && <Loading />}
                <ModalCustomized isOpen={openModal} toggle={toggleModal} title={titleModal} btnClose={toggleModal}>
                    <Row>
                        <Col>
                            {titleModal == "+ Justificar" &&
                                <TextField
                                    label={"* Tipo da justificativa"}
                                    type={"select"}
                                    options={notificacao.respostasJustificativa}
                                    searchable
                                    onChange={onChangeTipoJustificativa}
                                    name="tbTipoNotificacaoJustificativa_Id"
                                    invalid={errorsJustificativa.tbTipoNotificacaoJustificativa_Id}
                                    value={notificacao.respostasJustificativa && notificacao.respostasJustificativa.filter(v => v.value == justificativa.tbTipoNotificacaoJustificativa_Id)} />
                            }
                            <TextField
                                label={"* Justificativa"}
                                type={"textarea"}
                                name="observacoes"
                                invalid={errorsJustificativa.observacoes}
                                onChange={onChangeJustificativa}
                                value={justificativa.observacoes} />
                            {titleModal == "+ Justificar" &&
                                <>

                                    <TextField
                                        label={"Anexo"}
                                        type={"file"}
                                        onChange={onChangeAnexo}
                                        name="anexo"
                                        accept="image/png,image/jpeg" />
                                    {justificativa.anexoBase64 &&
                                        <Col md={"12"} lg={"12"} className="text-center mb-3">
                                            <img width={"300px"} id="anexo_justificativa" src={"data:image/png;base64," + justificativa.anexoBase64}></img>
                                        </Col>
                                    }
                                </>
                            }
                        </Col>
                    </Row>
                    <div className='d-flex align-items-center justify-content-center'>
                        <Button color='success' onClick={enviarAcao}>
                            <FontAwesomeIcon icon={faSave} /> Salvar
                        </Button>
                    </div>
                </ModalCustomized>
                <h5 className="rounded-3 bg-gradient bg-primary text-light p-2"><FontAwesomeIcon icon={faPencilAlt} className="me-2" /> Detalhes da notificação</h5>
                <Row>
                    <Col md="12" lg="12">
                        <p><span className="fw-bold">Tipo da notificação:</span> {notificacao?.tbTipoNotificacao_descricao}</p>
                    </Col>
                    <Col md="12" lg="6">
                        <p><span className="fw-bold">Data/Hora da notificação:</span> {moment(notificacao?.dataHora).format("DD/MM/YYYY HH:mm")}</p>
                    </Col>
                    <Col md="12" lg="6">
                        <p><span className="fw-bold">Prazo da justificativa:</span> {moment(notificacao?.prazoJustificativa).format("DD/MM/YYYY HH:mm")}</p>
                    </Col>
                    {usuario.acesso.sigla == "FS" &&
                        <Col md="12" lg="6">
                            <p><span className="fw-bold">Fiscal:</span> {notificacao?.nomeFiscal}</p>
                        </Col>
                    }
                    <Col md="12" lg="6">
                        <p><span className="fw-bold">Status:</span> {notificacao?.status}</p>
                    </Col>
                    <Col md="12" lg="6">
                        <p><span className="fw-bold">Nome do {notificacao?.categoria ?? "usuário"}:</span> {notificacao?.identificacao}</p>
                    </Col>
                    <Col md="12" lg="6">
                        <p><span className="fw-bold">CPF/CNPJ:</span> {notificacao?.cnpj}</p>
                    </Col>
                    <Col md="12" lg="6">
                        <p><span className="fw-bold">Email:</span> {notificacao?.email}</p>
                    </Col>
                    <Col md="12" lg="6">
                        <p><span className="fw-bold">Telefone:</span> {notificacao?.telefone}</p>
                    </Col>
                    <Col md="12" lg="6">
                        <p><span className="fw-bold">Enderenço:</span> {notificacao?.enderenco}</p>
                    </Col>
                </Row>
                <h5 className="rounded-3 bg-gradient bg-primary text-light p-2"><FontAwesomeIcon icon={faFileImage} className="me-2" /> Anexos</h5>
                <Row>

                    {notificacao.imagens && notificacao.imagens.map(value => {

                        return (
                            <Col md={"12"} lg={"4"} className={"mb-3 mt-3"}>
                                <img src={value.nomeArquivo} width="200px" height="300px" />
                            </Col>
                        )
                    })}
                </Row>
                {
                    (notificacao.status != "Baixado sem justificativa" && notificacao.status != "Notificação confirmada sem justificativa") && notificacao.justificativas && notificacao.justificativas.length > 0
                        ?
                        <>
                            <h5 className="rounded-3 bg-gradient bg-primary text-light p-2"><FontAwesomeIcon icon={faFileAlt} className="me-2" /> Justificativa</h5>
                            <p><span className="fw-bold">Usuário:</span> {notificacao.justificativas[0].nomeUsuario}</p>
                            <p><span className="fw-bold">Tipo de justificativa:</span> {notificacao.justificativas[0].tipoJustificativa}</p>
                            <p><span className="fw-bold">Justificativa:</span> {notificacao.justificativas[0].observacoes}</p>
                            {notificacao.justificativas[0].anexo &&
                                <Col md={"12"} lg={"12"} className=" mb-3">
                                    <img width={"300px"} id="anexo_justificativa" src={notificacao.justificativas[0].anexo}></img>
                                </Col>
                            }
                        </>
                        : <></>
                }
                {
                    notificacao.status != "Aguardando Justificativa" && notificacao.status != "Aguardando Análise" && notificacao.justificativas
                        ?
                        <>
                            <h5 className="rounded-3 bg-gradient bg-primary text-light p-2"><FontAwesomeIcon icon={faFileAlt} className="me-2" /> Analise do fiscal</h5>
                            <p><span className="fw-bold">Fiscal:</span> {notificacao.justificativas[0].nomeFiscal}</p>
                            <p><span className="fw-bold">Justificativa:</span> {notificacao.justificativas[0].observacoesFiscal}</p>
                        </>
                        : <></>
                }
            </div>
        </MainCard>
    )
}